import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { withRouter } from 'react-router';
import compose from 'recompose/compose';
import classNames from 'classnames';
import onClickOutside from 'react-onclickoutside';
import { EventEmitter } from 'events';
import ShopNameSwitcher from './ShopNameSwitcher';
import ShopSelect from './ShopSelect';

class HeaderShops extends Component {
  state = {
    shopDropdownActive: false,
  };

  handleClickOutside() {
    if (this.state.shopDropdownActive) {
      this.closeDropdown();
    }
  }

  closeDropdown() {
    this.setState({ shopDropdownActive: false });
  }

  toggleShopDropdown = (e) => {
    e.preventDefault();
    this.setState({ shopDropdownActive: !this.state.shopDropdownActive });
  };

  changeShopHandler = async (item) => {
    this.setState({ shopDropdownActive: false });
    if (item.id === this.props.activeId) {
      return;
    }

    await this.props.switchItem(item);
    if (item.type === 'shop') {
      EventEmitter.prototype.emit('change-shop');
    }
    this.props.router.push(this.props.router.location.pathname);
  };

  render() {
    const { activeName, collapsed, items, brandLogo, activeId, brandItem } = this.props;
    const { shopDropdownActive } = this.state;

    const shopDropdownClass = classNames(
      'c-shops-navigation', {
        'is-active': shopDropdownActive,
        'is-collapsed': collapsed,
      }
    );

    const logoClass = classNames('c-user-nav--logo', {
      rotated: shopDropdownActive,
      'brand-logo': shopDropdownActive && !!brandLogo,
    });
    const logoStyle = brandLogo ? { '--logo-background-image': `url(${brandLogo})` } : {};

    const shopElement = collapsed ?
                        null :
                        (<span className="c-user-nav__text">{activeName}</span>);

    return (
      <div className="u-position-relative">
        <ShopSelect
          onSelectItem={this.changeShopHandler}
          items={brandItem ? [brandItem, ...items] : items}
          activeItemId={activeId}
        />
        <li
          className="c-user-nav__link"
          title={activeName}
          style={{ cursor: 'pointer' }}
          onClick={this.toggleShopDropdown}
        >
          <div className={logoClass} style={logoStyle} />
          {shopElement}
        </li>
        <ShopNameSwitcher
          className={shopDropdownClass}
          activeId={activeId}
          onChange={this.changeShopHandler}
          items={items}
          brandItem={brandItem}
        />
      </div>
    );
  }
}

HeaderShops.propTypes = {
  switchItem: PropTypes.func.isRequired,
  activeName: PropTypes.string.isRequired,
  activeId: PropTypes.string.isRequired,
  collapsed: PropTypes.bool.isRequired,
  items: PropTypes.array.isRequired,
  brandLogo: PropTypes.string.isRequired,
  brandItem: PropTypes.object.isRequired,
};

export default compose(
  withRouter,
  onClickOutside
)(HeaderShops);
